export enum CustomerTypeEnum {
  personal = 'dashboard.user.individual',
  company = 'dashboard.user.company',
}
